var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF06A copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-home---single-page---modals",
    transform: "translate(-1155.000000, -755.000000)",
    fill: "#FF0085",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1185,815 C1201.5625,815 1215,801.5625 1215,785 C1215,768.4375 1201.5625,755 1185,755 C1168.4375,755 1155,768.4375 1155,785 C1155,801.5625 1168.4375,815 1185,815 Z M1188.59375,791.25 L1181.36719,791.25 C1180.625,791.25 1180.03906,790.820312 1180.03906,790.273438 L1179.375,766.015625 C1179.375,765.742188 1179.49219,765.46875 1179.76562,765.3125 C1180,765.117188 1180.35156,765 1180.70312,765 L1189.29688,765 C1189.64844,765 1190,765.117188 1190.23438,765.3125 C1190.50781,765.46875 1190.625,765.742188 1190.625,766.015625 L1189.92188,790.273438 C1189.88281,790.820312 1189.29688,791.25 1188.59375,791.25 Z M1188.78906,805 L1181.28906,805 C1180.58594,805 1180,804.414062 1180,803.710938 L1180,796.289062 C1180,795.585938 1180.58594,795 1181.28906,795 L1188.78906,795 C1189.45312,795 1190,795.585938 1190,796.289062 L1190,803.710938 C1190,804.414062 1189.45312,805 1188.78906,805 Z",
    id: "\\uF06A-copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.2b3ee4f0411c6b3216d9df618a9cc07a.svg";
export { ForwardRef as ReactComponent };